import { IOriginalItinCode } from '@eventr/common'
import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { TextOverlay } from '../../../common/textOverlay'
import { bs } from '../../../state/bound.store'
import { useFormatValue } from '../../../v2/hooks/useFormatValue'
import { ItineraryCard } from '../../components/itineraryCard'

interface IPublicItinEntryProps {
    itinCode: IOriginalItinCode
}
export const PublicItinEntry = ({ itinCode }: IPublicItinEntryProps) => {
    const { formatValue } = useFormatValue()
    return (
        <ItineraryCard
            title={
                <TextOverlay>
                    <Typography
                        variant={'bodyBold'}
                        style={{
                            padding: '0 4px',
                        }}
                    >
                        {itinCode.name ?? 'Imported Itinerary'}
                    </Typography>
                </TextOverlay>
            }
            description={
                itinCode.startRange && (
                    <TextOverlay>
                        <Typography variant={'bodySubtext'}>
                            {formatValue(itinCode.startRange, 'datetime')}
                            {itinCode.endRange
                                ? ` - ${formatValue(
                                      itinCode.endRange,
                                      'datetime'
                                  )}`
                                : ''}
                        </Typography>
                    </TextOverlay>
                )
            }
            actions={
                <Box
                    display={'grid'}
                    justifyItems={'center'}
                    alignItems={'center'}
                    padding={'0 16px 0 0'}
                    onClick={() => {
                        bs().removePublicItinerary(itinCode.code)
                    }}
                >
                    <Icon name="Delete" iconColour={ColoursObj.states.error} />
                </Box>
            }
        />
    )
}
